import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  icon,
  moreTo,
  moreLabel = "查看更多",
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-6 w-6 items-center justify-center text-primary-500">
              <i className={`${icon} text-xl`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action}
      {moreTo && !action && (
        <Link
          to={moreTo}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </span>
        </Link>
      )}
    </div>
  );
}